import {Mainmenu} from '../components/Mainmenu';
import {mainMenuEl, mainMenuParams} from './nav';

const mainNavsArr = Array.from(document.querySelectorAll('.menu__navigate'));
mainNavsArr.forEach((item, index, arr) => {
  const targetId = item.getAttribute('data-id');
  const mainNavMenuParams = {
      accordionActiveClass: 'menu__navigate_active',
      accordionBodySelector: '.menu__navigate_content',
      accordionTogglerSelector: `.menu__item[data-id="${targetId}"]`
  };
  const mainMenu = new Mainmenu(item, mainNavMenuParams, (data) => {
    const {isOpen,accordion} = data;
    const navItemsActiveArr = arr.filter(el => el != accordion);
    for(let i = 0; i < navItemsActiveArr.length; i++) {
      navItemsActiveArr[i].classList.remove(mainNavMenuParams.accordionActiveClass);
    }
    if(isOpen) {
      mainMenuEl.classList.remove(mainMenuParams.accordionActiveClass);
    }
  });
  mainMenu.setEventListeners();
});

const searchClassList = ['active', 'animate__animated', 'animate__backInRight'];
const headerSearchBtn = document.querySelector('.header__search-btn');
const headerSearchSubmit = document.querySelector('.header__search-submit');
const headerSearchInput = document.querySelector('.header__search-input');
if (headerSearchBtn) {
  headerSearchBtn.addEventListener('click', (e) => {
    headerSearchBtn.classList.toggle('d-none');
    headerSearchSubmit.classList.toggle('d-none');
    searchClassList.forEach(el => {
      headerSearchInput.classList.toggle(el);
    }) 
  });
}
/*
const pwdHoldersArr = Array.from(document.querySelectorAll('.form__item-pwd'));
function togglePwdHolder(el) {
  const pwdButton = el.querySelector('.form-pwd__button-eye');
  const pwdField = el.querySelector('.form-pwd__field');

  function toggle() {
    if(pwdField.type == 'password') {
      pwdField.type = 'text'; 
      pwdButton.classList.add('form-pwd__button-eye_active');
    }
    else {
      pwdField.type = 'password';
      pwdButton.classList.remove('form-pwd__button-eye_active');
    }
  }
  
  return {
    toggle
  };
}
pwdHoldersArr.forEach(el => {
  const togglePwd = togglePwdHolder(el);
  const pwdButton = el.querySelector('.form-pwd__button-eye');
  pwdButton.addEventListener('click', (e) => {
    togglePwd.toggle();
  });
});
*/